import { render, staticRenderFns } from "./TourismSuccess.vue?vue&type=template&id=723366f2&scoped=true&"
import script from "./TourismSuccess.vue?vue&type=script&lang=js&"
export * from "./TourismSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TourismSuccess.vue?vue&type=style&index=0&id=723366f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723366f2",
  null
  
)

export default component.exports